module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Never say goodbye because goodbye means going away and going away means forgetting.")])]), _vm._v(" "), _c('p', {
    staticClass: "cepc"
  }, [_vm._v("J.M. Barrie, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Peter Pan")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Thursday, 25 June 2009. In time zones around the world, the news was dominated by one headline: ‘Michael Jackson, the “King of Pop”, is dead.’")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("Earlier that day, at 13:14 Pacific Standard Time (PST), an ambulance had arrived at the Ronald Reagan UCLA Medical Center in Los Angeles. Anxious to shield the identity of the patient it was carrying from the gathering press, the vehicle reversed up to the doors of the Emergency Room (ER) and a towel was placed over the face of the casualty. The ambulance was returning from a 911 emergency call placed at 12:21 PST, some 53 minutes earlier. Alberto Alvarez had made the call from a mansion in nearby Carolwood Drive.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This mansion, in the prestigious area of Holmby Hills, was being rented for $100,000 per month by a man who was once the biggest pop star in the world and who remained one of the most famous and fascinating figures on the planet: Michael Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jackson was in Los Angeles to rehearse and prepare for his upcoming and eagerly anticipated ‘This Is It’ comeback tour, which consisted of 50 sold-out shows in the UK at London’s O2 Arena and which was scheduled to begin in just 13 days time.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Jackson’s rented property was only four minutes from UCLA. The 911 call was frantic with audible commotion in the background, including the angry voice of someone speaking in an undistinguishable foreign language:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Paramedic 33, what is the nature of your emergency?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" Yes, sir, I need an ambulance as soon as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Okay, sir, what is your address?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" Los Angeles, California, 90077.")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Is it Carolwood?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" Carolwood Drive, yes [barely audible]")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Okay, sir, what’s the phone number you’re calling from and [barely audible] and what exactly happened?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" Sir, we have a gentleman here that needs help and he’s not breathing, he’s not breathing and we need to – we’re trying to pump him but he’s not …")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Okay, how old is he?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" He’s fifty years old, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Fifty? Okay, he’s unconscious and he’s not breathing?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" Yes, he’s not breathing, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("911 Operator:")]), _vm._v(" Okay, and he’s not conscious either?")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Alvarez:")]), _vm._v(" No, he’s not conscious, sir."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-01",
      "id": "notes-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Neither the 911 operator, nor the team of paramedics dispatched from Fire Station 71 in Bel Air to this emergency call were aware that the ‘gentleman’ who was unconscious and not breathing was none other than Michael Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They didn’t even initially recognise Jackson when they arrived at his beside at 12:26 (PST). Paramedic Richard Senneff, who testified at the 2011 trial into Jackson’s death, said: ‘And the patient, he appeared to me to be pale and underweight. I was thinking along the lines of this is a hospice patient.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-02",
      "id": "notes-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the next 31 minutes, Senneff and his team of paramedics worked tirelessly on Jackson’s body to save his life. It appeared a futile task. All the evidence in front of them suggested that Jackson had gone into arrest long before they had arrived, but one man present in the room convinced the paramedics to continue. ‘It had just happened’, he said of the patient’s arrest. This man was Dr Conrad Murray, Jackson’s personal physician.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Regardless of his assurances, Paramedic Senneff wasn’t convinced. ‘There is a lot of little variables. But all I can tell you is it was my gut feeling at the time this did not just happen’, Senneff said at the 2011 trial.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nevertheless, Senneff and his team continued though, despite their best efforts, they could not revive the ‘King of Pop’. Throughout the procedure, Richard Senneff was in contact with UCLA, whose doctors and nurses were relaying to him standard orders for the procedure via mobile phone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At 12:57 (PST), Senneff and his team were advised over the mobile phone by Dr Richelle Cooper at UCLA that all attempts were futile, they had done all they could, and permission was given to pronounce the patient dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr Murray, however, was determined not to accept this pronunciation of death and, inspecting the patient himself, declared that he had felt a femoral pulse in Jackson’s neck. Paramedic Senneff checked the same area. He felt nothing, but Murray implored the paramedics to continue, demanding that Jackson be transferred to UCLA for further care.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Richard Senneff discussed the situation with UCLA, relaying the conversation he had had with Dr Murray and explaining that the patient’s personal physician wasn’t comfortable with the decision to stop treatment at that point. UCLA replied by asking if Dr Murray was willing to assume complete control of the call and, if so, whether he was also willing to accompany the patient in the ambulance to the hospital. Dr Murray responded categorically that he "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("would")]), _vm._v(" assume control. In his statement to police, Dr Murray would later say:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("I mean I love Mr. Jackson. He was my friend. And he opened up to me in different ways. And I wanted to help him as much as I can. You know, he was a single parent. You don’t always hear that from a man. But he would state that, you know, he was a single parent of three. And I – I always thought of his children, you know, as I would think about mine. So I wanted to give him the best chance."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-03",
      "id": "notes-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("With the paramedics now having relinquished authority, Jackson was placed on a gurney and put in the ambulance at 13:07 (PST). It was now over 40 minutes since the paramedics had first arrived at the scene.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the ambulance slowly reversed out into the street, a bus carrying 13 tourists on a guided tour of the homes of Hollywood stars saw the drama unfold. ‘This is Michael Jackson’s estate everyone,’ the tour guide announced, ‘so we’ll find out later in the news what happened.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-04",
      "id": "notes-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By this stage, the broadcasters, bloggers, paparazzi and the internet outlets were aware that something was happening with Michael Jackson, and the ambulance was followed by an increasing number of cars, motorcycles and helicopters as it made its way to UCLA.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Seven minutes later, the ambulance backed up to the UCLA Medical Center door. A crowd had already begun to gather and hospital security had yet to be deployed. Dr Murray asked, before Jackson was taken off the ambulance, whether a towel or something could be put over Michael’s face. When this was done, the back doors of the ambulance were opened and the gurney carrying the body of Michael Jackson was rolled through the security corridor and right into the ER where Dr Richelle Cooper and her team of 14 staff were ready to go to work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr Murray had also made his way into the ER and immediately came face-to-face with Dr Cooper who, just under 20 minutes earlier, had been prepared, according to LA County EMS"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-05",
      "id": "notes-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Protocols, to pronounce Michael Jackson dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The first thing Dr Cooper wanted to know from Dr Murray, as Jackson was being placed on monitors, was Murray’s interpretation of what had happened. He simply told her that the patient had not been ill but had been working long hours, that Jackson had had trouble sleeping and was dehydrated."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-06",
      "id": "notes-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr Cooper asked about any narcotics Dr Murray might have given the patient and he stated that he had given Jackson 2mg of Lorazepam, a drug generally used to treat anxiety disorders, at some point during the morning and then later given him another 2mg of the same drug before he witnessed the patient arrest."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-07",
      "id": "notes-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She continued to ask Dr Murray about any other drug administration, drug use or history of drug use in the patient. Murray told her that Jackson was also taking Flomax (used for urinary problems in someone who has a large prostate) and Valium (used, like Lorazepam, as a sedative)."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-08",
      "id": "notes-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Following this brief exchange, Dr Murray could only watch on as Dr Cooper and her team did everything possible to revive the stricken Jackson.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Dr Cooper later testified:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("There was a report by Dr Murray that he had felt a faint pulse separate, which conflicted with the report of the paramedics that there wasn’t a pulse. When the patient arrived, I made the decision we will attempt to resuscitate to confirm.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Dr Cooper and her team resumed CPR on Jackson, administered more medications, including initial IV fluids (based on the reported dehydration) and ventilated the patient – but everyone in the room was aware they were fighting a losing battle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a small glimmer of hope at 13:21 (PST) when one of the medical team thought they found a weak femoral pulse in Jackson but, despite more medication being administered, there was no return to what Dr Cooper described as ‘… spontaneous circulation’."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-09",
      "id": "notes-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Another member of the medical team at UCLA, Cardiology Fellow Dr Thao Nguyen, also spoke to Dr Murray to enquire about the medication he might have already administered to Jackson. Dr Murray said he had given Jackson 4mg of Ativan (a trademarked name for Lorazepam) and then continued to say he ‘… later found the patient not breathing’."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-010",
      "id": "notes-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Dr Nguyen asked Dr Murray for any recollection of time, such as when he found the patient not breathing or when he had found Jackson in relation to the 911 call, but Dr Murray simply responded that he ‘… had no concept of time’."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-011",
      "id": "notes-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While the ER medical team continued their efforts to revive Jackson, elsewhere in the hospital friends and family of the singer were arriving, among them Jackson’s mother, Katherine, his three children (Prince, Paris and Blanket) and his brother Jermaine. As they all gathered they had to pass the room where the medical team were working frantically on Jackson. ‘Outside the room we heard them working on him. We thought he was alive’ said one of those gathered, Jackson’s ex-manager Frank Dileo."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-012",
      "id": "notes-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Meanwhile, Dr Murray was continuing to watch events unfolding in the ER, as the medical staff made one last effort to save Jackson by inserting an intra-aortic balloon pump: a mechanical device that helps the heart pump blood that is often used for drug-induced cardiovascular failure and increases the oxygen supply direct to the heart muscle. However, as Dr Thao Nguyen stated in her testimony at the 2011 trial, such a procedure is a ‘… last ditch effort’, and was not generally used on a patient without a pulse, but the procedure was implemented in this instance ‘… per request of Murray not to give up easily’."), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-013",
      "id": "notes-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dr Nguyen also stated that ‘… before inserting the balloon pump, there was an understanding made with Dr Murray that if this method or measure should fail to revive the patient, or resuscitate the patient successfully, we will call it quits.’"), _c('span', {
    staticClass: "epub-sup-fn"
  }, [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes#notes-014",
      "id": "notes-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The balloon pump was successfully inserted into Jackson but it failed to revive him and, at 14:26 (PST), the singer was pronounced dead.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While this drama was unfolding inside UCLA Medical Center, outside the hospital walls various media outlets were drawing their own conclusions. The USA celebrity website, "), _c('a', {
    attrs: {
      "href": "http://TMZ.com",
      "target": "_blank"
    }
  }, [_vm._v("TMZ.com")]), _vm._v(", was the first to post news of Michael Jackson being unwell and stated that the singer had been taken to a hospital in Los Angeles after suffering a heart attack. There was no confirmation from reliable sources however, and the hospital itself was prevented from making statements owing to patient confidentiality. Even Michael Jackson’s father, Joe, was unable to shed any light on the events taking place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it wasn’t long before the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Los Angeles Times")]), _vm._v(" claimed it had verified the news that Jackson was not breathing when paramedics arrived at his Carolwood mansion. And the news all Jackson fans had been dreading arrived just minutes later when "), _c('a', {
    attrs: {
      "href": "http://TMZ.com",
      "target": "_blank"
    }
  }, [_vm._v("TMZ.com")]), _vm._v(", despite no formal confirmation, published a story, which began: ‘We’ve just learned Michael Jackson has died. He was 50.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Given "), _c('a', {
    attrs: {
      "href": "http://TMZ.com",
      "target": "_blank"
    }
  }, [_vm._v("TMZ.com")]), _vm._v("’s reputation for showbiz scoops, many began to believe that this story was accurate and news channels across the planet began reporting Jackson’s death, even though it was still unconfirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Eventually, the Los Angeles Coroner’s Office announced that Jackson had been pronounced dead at 14:26 local time and almost four hours later Michael’s brother, Jermaine, delivered a carefully worded statement to a gathering of media in the UCLA Medical Center’s conference room. In it he said:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("This is hard. My brother, the legendary King of Pop, Michael Jackson, passed away on Thursday, June 25th, 2009, at 2:26pm. It is believed he suffered cardiac arrest in his home. However, the cause of death is unknown until the results of the autopsy are known.")]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("Over the next two months Michael Jackson’s body underwent two autopsies, and samples of hair were taken from his corpse for further possible toxicological investigation. The results of these autopsies opened a window to the world on the shocking and tragic life of Michael Jackson. A life that had become, in his later years, swamped and consumed by paranoia, deceit, drug abuse, greed and manipulation. They painted a painful and brutal portrait of an entertainer in the midst of a storm that was always destined to blow itself out in tragic circumstances. They also raised many questions about what really happened to Michael Jackson. And, ultimately, who was responsible for his death.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To find the answers to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("these")]), _vm._v(" questions, we need to ask just how did Michael Jackson get to that fateful day in June 2009?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8dfc14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0